export const HEARING_ELIGIBILITY_DETERMINATION_TYPE_CODE = "hearing_eligibility";

export interface EligibilityDetermination {
  id: number;
  subjectKey: string;
  incarceratedPersonId?: number | null;
  determinationTypeCode: string;
  ruleSetCode: string;
  ruleSetVersion?: string | null;
  statusCode: string;
  calculationAsOfDate: string;
  calculatedUtc: string;
  nextEligibleDate?: string | null;
  isCurrent: boolean;
  supersededByDeterminationId?: number | null;
  supersededUtc?: string | null;
  result?: EligibilityDeterminationResult | null;
}

export interface EligibilityDeterminationCalculateRequest {
  determinationTypeCode: string;
  ruleSetCode?: string | null;
  calculationAsOfDate: string;
}

export interface EligibilityDeterminationResult {
  statusCode: string;
  nextEligibleDate?: string | null;
  requiredActionCodes: string[];
  appliedRules: EligibilityRuleVersionReference[];
  reasons: EligibilityDeterminationReason[];
  blockingReasonCodes: string[];
  pendingInformationReasonCodes: string[];
  warningReasonCodes: string[];
}

export interface EligibilityRuleVersionReference {
  ruleCode: string;
  ruleVersion: string;
  ruleSetCode: string;
  effectiveFrom: string;
  effectiveTo?: string | null;
  citation?: string | null;
}

export interface EligibilityDeterminationReason {
  ruleCode: string;
  ruleVersion: string;
  ruleSetCode: string;
  contributionCode: string;
  reasonCode: string;
  explanation: string;
  date?: string | null;
  requiredActionCode?: string | null;
  isPermanent: boolean;
}

export interface EligibilityStatusSummary {
  statusCode?: string | null;
  nextEligibleDate?: string | null;
  pendingInformationReasonCodes?: readonly string[] | null;
  blockerReasonCodes?: readonly string[] | null;
}

export interface EligibilityExplanation {
  determinationTypeCode?: string | null;
  ruleSetCode?: string | null;
  ruleSetVersion?: string | null;
  calculationAsOfDate?: string | null;
  calculatedUtc?: string | null;
  isCurrent?: boolean | null;
  requiredActionCodes?: readonly string[] | null;
  appliedRules?: readonly EligibilityRuleVersionReference[] | null;
  reasons?: readonly EligibilityDeterminationReason[] | null;
  warningReasonCodes?: readonly string[] | null;
}

export function toEligibilityStatusSummary(
  determination: EligibilityDetermination | null | undefined,
): EligibilityStatusSummary | null {
  if (!determination) {
    return null;
  }

  return {
    statusCode: determination.statusCode,
    nextEligibleDate: determination.nextEligibleDate ?? determination.result?.nextEligibleDate ?? null,
    pendingInformationReasonCodes: determination.result?.pendingInformationReasonCodes ?? [],
    blockerReasonCodes: determination.result?.blockingReasonCodes ?? [],
  };
}

export function toEligibilityExplanation(
  determination: EligibilityDetermination | null | undefined,
): EligibilityExplanation | null {
  if (!determination) {
    return null;
  }

  return {
    determinationTypeCode: determination.determinationTypeCode,
    ruleSetCode: determination.ruleSetCode,
    ruleSetVersion: determination.ruleSetVersion ?? null,
    calculationAsOfDate: determination.calculationAsOfDate,
    calculatedUtc: determination.calculatedUtc,
    isCurrent: determination.isCurrent,
    requiredActionCodes: determination.result?.requiredActionCodes ?? [],
    appliedRules: determination.result?.appliedRules ?? [],
    reasons: determination.result?.reasons ?? [],
    warningReasonCodes: determination.result?.warningReasonCodes ?? [],
  };
}
